import { useIsFeatureEnabled } from '@fluentsms/feature-flags';
import { Fee } from '@fluentsms/graphql';
import { useMemo, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

export interface StatementPayeeDisplayNameProps {
  formFieldValue: string;
  inputTextFocused: boolean;
  shouldShowMenuOption: boolean;
  shouldShowTextInput: boolean;
  setFormFieldValue: (value: string) => void;
  setInputTextFocused: React.Dispatch<React.SetStateAction<boolean>>;
  setShouldShowTextInput: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useStatementPayeeDisplayName = (
  formMethods: UseFormReturn<Fee, object>,
): StatementPayeeDisplayNameProps => {
  const statementPayeeDisplayName: keyof Fee = 'statementPayeeDisplayName';
  const formFieldValue = formMethods.watch(statementPayeeDisplayName) || '';

  const [shouldShowTextInput, setShouldShowTextInput] = useState(Boolean(formFieldValue));
  const [inputTextFocused, setInputTextFocused] = useState(false);

  return useMemo(
    () => ({
      formFieldValue,
      inputTextFocused,
      shouldShowMenuOption: !shouldShowTextInput && !formFieldValue,
      shouldShowTextInput,
      setFormFieldValue: (value: string) =>
        formMethods.setValue(statementPayeeDisplayName, value, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        }),
      setInputTextFocused,
      setShouldShowTextInput,
    }),
    [formFieldValue, formMethods, inputTextFocused, shouldShowTextInput],
  );
};
